/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Scene_DescriptionsInputs */

const en_automatic_scene_descriptions = /** @type {(inputs: Automatic_Scene_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Shot Descriptions`)
};

const fr_automatic_scene_descriptions = /** @type {(inputs: Automatic_Scene_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descriptions automatiques des prises de vue`)
};

const de_automatic_scene_descriptions = /** @type {(inputs: Automatic_Scene_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Schussbeschreibungen`)
};

const it_automatic_scene_descriptions = /** @type {(inputs: Automatic_Scene_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizioni automatiche delle inquadrature`)
};

const ru_automatic_scene_descriptions = /** @type {(inputs: Automatic_Scene_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание автоматических выстрелов`)
};

const es_automatic_scene_descriptions = /** @type {(inputs: Automatic_Scene_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripciones de tomas automáticas`)
};

const zh_cn2_automatic_scene_descriptions = /** @type {(inputs: Automatic_Scene_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动拍摄描述`)
};

const ja_automatic_scene_descriptions = /** @type {(inputs: Automatic_Scene_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動撮影の説明`)
};

const hi_automatic_scene_descriptions = /** @type {(inputs: Automatic_Scene_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित शॉट विवरण`)
};

const pt_pt2_automatic_scene_descriptions = /** @type {(inputs: Automatic_Scene_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrições automáticas de disparos`)
};

/**
* | output |
* | --- |
* | "Automatic Shot Descriptions" |
*
* @param {Automatic_Scene_DescriptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_scene_descriptions = /** @type {((inputs?: Automatic_Scene_DescriptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Scene_DescriptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_scene_descriptions(inputs)
	if (locale === "de") return de_automatic_scene_descriptions(inputs)
	if (locale === "it") return it_automatic_scene_descriptions(inputs)
	if (locale === "ru") return ru_automatic_scene_descriptions(inputs)
	if (locale === "es") return es_automatic_scene_descriptions(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_scene_descriptions(inputs)
	if (locale === "ja") return ja_automatic_scene_descriptions(inputs)
	if (locale === "hi") return hi_automatic_scene_descriptions(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_scene_descriptions(inputs)
	return en_automatic_scene_descriptions(inputs)
});